export interface PendingBudgetExpense {
    expenseName?: string;
    categoryId?: number;
    budgetId?: number;
    amount?: string;
    expenseDate?: string; // YYYY-MM-DD
    status?: string;
}

export interface PendingDeleteBudgetExpense {
    awaitingName?: boolean;
}
export const startCreateBudgetExpenseFlow = (
    setPending: (data: PendingBudgetExpense | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPending({ expenseName: nameFromIntent });
        pushAIChat("Please select the category.");
        speak("Please select the category.");
        return;
    }

    setPending({});
    pushAIChat("What is the expense name?");
    speak("What is the expense name?");
};
export const processPendingBudgetExpense = (
    text: string,
    pending: PendingBudgetExpense,
    setPending: (data: PendingBudgetExpense | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — Expense Name
    if (!pending.expenseName) {
        const name = text.trim();
        if (!name) {
            pushAIChat("Please provide a valid expense name.");
            speak("Please provide a valid expense name.");
            return;
        }

        setPending({ ...pending, expenseName: name });

        pushAIChat("Please select a category.");
        speak("Please select a category.");

        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "budget-expense-category" }
            })
        );
        return;
    }

    // STEP 2 — Category (from option select)
    if (!pending.categoryId) return;

    // STEP 3 — Budget
    if (!pending.budgetId) {
        pushAIChat("Please select a budget.");
        speak("Please select a budget.");

        window.dispatchEvent(
            new CustomEvent("ai-suggest-options", {
                detail: { type: "budget-expense-budget" }
            })
        );
        return;
    }

    // STEP 4 — Amount
    if (!pending.amount) {
        const amount = text.replace(/[^0-9.]/g, "");
        if (!amount) {
            pushAIChat("Please provide a valid amount.");
            speak("Please provide a valid amount.");
            return;
        }

        setPending({ ...pending, amount });

        pushAIChat("Please provide the expense date.");
        speak("Please provide the expense date.");
        return;
    }

    // STEP 5 — Date (FINAL)
    if (!pending.expenseDate) {
        setPending({ ...pending, expenseDate: text, status: "active" });

        pushAIChat(`Creating budget expense "${pending.expenseName}"...`);
        speak(`Creating budget expense ${pending.expenseName}.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-budget-expense", {
                detail: {
                    ...pending,
                    expenseDate: text,
                    status: "active"
                }
            })
        );

        setPending(null);
        return;
    }
};
export const startDeleteBudgetExpenseFlow = (
    setPendingDelete: (data: PendingDeleteBudgetExpense | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting budget expense "${nameFromIntent}"...`);
        speak(`Deleting budget expense ${nameFromIntent}.`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-budget-expense", {
                detail: { name: nameFromIntent }
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which budget expense would you like to delete?");
    speak("Which budget expense would you like to delete?");
};
export const processPendingDeleteBudgetExpense = (
    text: string,
    pending: PendingDeleteBudgetExpense,
    setPendingDelete: (data: PendingDeleteBudgetExpense | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    const cleanName = text.trim();
    if (!cleanName) {
        pushAIChat("Please provide a valid expense name.");
        speak("Please provide a valid expense name.");
        return;
    }

    pushAIChat(`Deleting budget expense "${cleanName}"...`);
    speak(`Deleting budget expense ${cleanName}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-budget-expense", {
            detail: { name: cleanName }
        })
    );

    setPendingDelete(null);
};
